import styled from "styled-components";

export const FilmDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  margin: 20px auto;
  max-width: 1200px;
  width: 90%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2rem;
    /* margin-bottom: 30px; */
  }
`;


export const LeftColumn = styled.div`
  flex-shrink: 0;
  width: 100%;
  
  @media (min-width: 768px) {
    width: 40%;
  }
`;

export const RightColumn = styled.div`
  width: 100%;
  padding-top: 1rem;
  
  @media (min-width: 768px) {
    flex: 1;
    /* padding-top: 0; */
  }
`;

export const FilmImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
  margin-bottom: 20px;
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
`;

export const FilmTitle = styled.h1`
  font-weight: 900;
  margin-top: 0;

  /* @media (max-width: 767px) {
    text-align: center;
  } */
`;

export const ExternalLinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  border-radius: 0.3125rem;
  border: none;
  background-color: rgba(0, 0, 0, 0.1);
  color: #000;
  font-family: ${(props) => props.theme.fonts.primary};
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #7F7F7F;
    color: #fff;
  }

  &:active {
    background-color: #000;
    color: #fff;
  }
`;

export const ScreeningsContainer = styled.div`
  width: 100%;
  /* padding-top: 20px; */
  border-top: 1px solid #eee;
  
  @media (min-width: 768px) {
    flex-basis: 100%;
  }
`;

export const ScreeningsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;

  li {
    padding: 12px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: #f0f0f0;
    }
  }
`;

export const LockButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${(props) => (props.$isLocked ? "#000" : "#bbb")};
  transition: color 0.2s, background-color 0.2s;

  &:hover {
    color: ${(props) => (props.$isLocked ? "#333" : "#666")};
    background-color: rgba(0, 0, 0, 0.05);
  }

  svg {
    font-size: 1.25rem;
  }
`;

export const NavigationArrow = styled.button`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  padding: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.left {
    left: 20px;
  }

  &.right {
    right: 20px;
  }

  @media (max-width: 768px) {
    padding: 10px;
    
    &.left {
      left: 10px;
    }
    
    &.right {
      right: 10px;
    }
  }
`;

export const CalendarWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 2rem;
`;

export const ShortFilmSubtitle = styled.p`
  font-style: italic;
  font-size: 0.9rem;
  color: #666;
  margin-top: -0.5rem;

  a {
    color: #666;
    text-decoration: underline;

    &:hover {
      color: #333;
    }
  }
`;